import { useState } from 'react';
import { auth } from './api';
import { Link, usePath } from './router';
import { ConfigPage } from './pages/config';
import { UsersPage } from './pages/users';
import { ShopPage } from './pages/shop';
import { ContentPage, LoginPage, OpsPage, ReportsPage } from './pages/misc';
import { AnalyticsPage } from './pages/analytics';

const ROUTES: Record<string, () => JSX.Element> = {
  '/': ConfigPage,
  '/config': ConfigPage,
  '/users': UsersPage,
  '/shop': ShopPage,
  '/analytics': AnalyticsPage,
  '/reports': ReportsPage,
  '/content': ContentPage,
  '/ops': OpsPage,
};

export function App() {
  const path = usePath();
  const [authed, setAuthed] = useState(Boolean(auth.token));

  if (!authed) return <LoginPage onLoggedIn={() => setAuthed(true)} />;

  const Page = ROUTES[path] ?? (() => <h1>Страница не найдена</h1>);

  return (
    <div className="shell">
      <aside>
        <div className="brand">Бонусная программа</div>
        <nav>
          <Link to="/config">Настройки начислений</Link>
          <Link to="/shop">Лавка</Link>
          <Link to="/users">Ученики</Link>
          <Link to="/analytics">Аналитика</Link>
          <Link to="/reports">Отчёты</Link>
          <Link to="/content">Тексты и вопросы</Link>
          <Link to="/ops">Эксплуатация</Link>
        </nav>
        <div className="foot">
          <button
            className="secondary small"
            onClick={() => {
              auth.clear();
              setAuthed(false);
            }}
          >
            Выйти
          </button>
        </div>
      </aside>
      <main>
        <Page />
      </main>
    </div>
  );
}
